import React from 'react';
import styles from './Modal.module.css';

const Modal = ({ onClose, onConfirm, children, confirmText = "OK", cancelText = "Peruuta", showCancelButton = false, size = 'medium' }) => {
  const sizeClass = size === 'small' ? styles.small : size === 'large' ? styles.small : size === 'smallmedium' ? styles.smallmedium : styles.medium;

  return (
    <div className={styles.modalOverlay}>
      <div className={`${styles.modalContent} ${sizeClass}`}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        {children}
        <div className={styles.buttonContainer}>
          <button className={styles.confirmButton} onClick={onConfirm || onClose}>{confirmText}</button>
          {showCancelButton && (
            <button className={styles.cancelButton} onClick={onClose}>{cancelText}</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;